import classNames from 'classnames'
import { MdOutlineClear } from 'react-icons/md'
import ReactModal from 'react-modal'

import type { ReactElement, PropsWithChildren } from 'react'

import Button from '~/components/Buttons/Button'

import './styles.scss'

export interface Props {
  className?: string
  isOpen: boolean
  onClosePanel: VoidFunction
  panelRef?: ((instance: HTMLDivElement) => void) | undefined
}

const Panel = ({ children, className, isOpen, onClosePanel, panelRef }: PropsWithChildren<Props>): ReactElement => {
  return (
    <ReactModal
      // NOTE: as we don't care about screen readers, we can safely disable ariaHideApp
      ariaHideApp={false}
      className={classNames('panel-component', className, { 'panel-component--open': isOpen })}
      closeTimeoutMS={300}
      contentRef={panelRef}
      isOpen={isOpen}
      onRequestClose={onClosePanel}
      overlayClassName="panel-overlay"
    >
      <Button className="close-btn" ghost onClick={onClosePanel}>
        <MdOutlineClear size={15} />
      </Button>
      {children}
    </ReactModal>
  )
}

export default Panel
